/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
const routes = [
    {
        name: 'login',
        path: '/admin/login',
        component: () => import('@/app/login/login.vue'),
        title: 'Login',
        isPublic: true,
    },
    {
        name: 'validate2fa',
        path: '/admin/validate2fa',
        component: () => import('@/app/login/validate2fa.vue'),
        title: '2-Faktor-Auth',
        isPublic: true,
    },
    {
        name: 'disable2fa',
        path: '/disable2fa',
        component: () => import('@/app/account/settings/disable2fa.vue'),
        title: 'Disable 2-Faktor-Auth',
        isPublic: true,
    },
    {
        name: 'confirmation',
        path: '/confirmation',
        component: () => import(/* webpackChunkName: "confirmation" */ '@/app/account/settings/confirmation.vue'),
        title: 'Confirmation',
        isPublic: true,
    },
    {
        name: 'home',
        path: '/',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/app/home/home.vue'),
        title: 'Home',
        isPublic: true,
    },
    {
        name: 'passwordreset',
        path: '/admin/passwordreset',
        component: () => import(/* webpackChunkName: "passwordreset" */ '@/app/account/settings/passwordreset.vue'),
        title: 'Account',
        isPublic: true,
    },
    {
        name: 'passwordresetfinish',
        path: '/admin/reset/finish',
        component: () => import(/* webpackChunkName: "passwordresetfinish" */ '@/app/account/settings/passwordreset_finish.vue'),
        title: 'Account',
        isPublic: true,
    },
    {
        name: 'useradministration_list',
        path: '/admin/useradministration',
        component: () => import('@/app/administration/useradministration_list.vue'),
        title: 'Useradministation',
        isPublic: false,
        allowedRoles: ['ADMIN_ROLE'],
        auswertung: false,
    },
    {
        name: 'useradministration',
        path: '/admin/useradministration/:slug',
        component: () => import('@/app/administration/useradministration.vue'),
        title: 'Useradministation',
        isPublic: false,
        allowedRoles: [
            'ADMIN_ROLE',
            'USERADMIN_ROLE',
        ],
        auswertung: false,
    },
    {
        name: 'settings',
        path: '/admin/settings/:slug',
        component: () => import(/* webpackChunkName: "settings" */ '@/app/account/settings/settings.vue'),
        title: 'Settings',
        isPublic: false,
        allowedRoles: [
            'ADMIN_ROLE',
            'STANDARD_ROLE',
            'USERADMIN_ROLE',
        ],
        auswertung: false,
    },
    {
        name: 'changepassword',
        path: '/admin/changepassword/:slug',
        component: () => import(/* webpackChunkName: "changepassword" */ '@/app/account/settings/password.vue'),
        title: 'Passwort',
        isPublic: false,
        allowedRoles: [
            'ADMIN_ROLE',
            'STANDARD_ROLE',
            'USERADMIN_ROLE',
        ],
        auswertung: false,
    },
    {
        name: 'register',
        path: '/register',
        component: () => import(/* webpackChunkName: "register" */ '@/app/account/settings/register.vue'),
        title: 'Registrierung',
        isPublic: false,
        allowedRoles: ['ADMIN_ROLE'],
        auswertung: false,
    },
    {
        name: 'offer',
        path: '/offer/:slug?',
        component: () => import(/* webpackChunkName: "offer" */ '@/app/offer/offer.vue'),
        title: 'Angebot',
        isPublic: false,
        allowedRoles: [
            'ADMIN_ROLE',
            'STANDARD_ROLE',
            'USERADMIN_ROLE',
        ],
        auswertung: false,
    },
    {
        name: 'offer_list',
        path: '/offerlist',
        component: () => import(/* webpackChunkName: "offer" */ '@/app/offer/offer_list.vue'),
        title: 'Angebotsübersicht',
        isPublic: false,
        allowedRoles: [
            'ADMIN_ROLE',
            'STANDARD_ROLE',
            'USERADMIN_ROLE',
        ],
        auswertung: false,
    },
    {
        name: 'offerevaluation',
        path: '/offerevaluation',
        component: () => import(/* webpackChunkName: "offer" */ '@/app/offerevaluation/offerevaluation.vue'),
        title: 'Angebotsauswertung',
        isPublic: false,
        allowedRoles: [
            'ADMIN_ROLE',
            'STANDARD_ROLE',
            'USERADMIN_ROLE',
        ],
        auswertung: true,
    },
];

export default routes;
